import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { CustomersContext } from "./CustomersContext";

export const useCustomersContext = () => {
  const context = useContext(CustomersContext);

  if (!context) {
    throw new HookOutOfContextError("useCustomersContext", "CustomersContext");
  }

  return context;
};
